import 'whatwg-fetch';
import 'idempotent-babel-polyfill';
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import queryString from 'query-string';

var listLoads = [];
var autoCompletePath = '';

async function autocompleteApi(data) {
  autoCompletePath = ProductFinder.options.settings.autoCompletePath;

  let query = {};
  let queryPath = autoCompletePath;
  query['search'] = data.search;

  queryPath = queryPath + '?' + queryString.stringify(query, { arrayFormat: 'bracket' });
  // Get the current sort.
  listLoads.forEach((control) => {
    control.abort();
  })
  listLoads = [];
  const controller = new AbortController();
  listLoads.push(controller);
  const signal = controller.signal;
  try {
    const response = await window.fetch(queryPath, { signal: signal });
    return await response.json();
  } catch (e) {
    return null;
  }
}

export default autocompleteApi;
